import { useMemo } from "react";
import { RouteNames } from "utils/constants";
import { usePathnameWithLocal } from "./base";

export const useCasinoScope = () => {
    const { pathnameValues } = usePathnameWithLocal();

    const scope = useMemo(() => {
        const path = pathnameValues[1];
        switch (path) {
            case RouteNames.SLOTS:
            case RouteNames.LIVE_CASINO:
                return path;
            default:
                return null;
        }
    }, [pathnameValues]);

    return {
        scope,
        isSlotsScope: scope === RouteNames.SLOTS,
        isLiveCasinoScope: scope === RouteNames.LIVE_CASINO,
    };
};
